import { useEffect, useRef, useState } from 'react'
import FavoriteStar from '../../../../Components/Components/FavoriteStar';
import useGetProductPrices from '../../../../Components/BasketPage/Hooks/useGetProductPrices';
import { useNavigate } from 'react-router-dom';
import useHandleAddToBasketBtn from '../../Hooks/useHandleAddToBasketBtn';
import { useCart } from '../../../../Providers/CartProvider';
import { ConvertPriceToString, CapitalizeFirstLowercaseRest } from '../../../../Helpers/CustomConverter';
import { useLastWatchedProducts } from '../../../../Providers/LastWatchedProductsProvider';
import { useAuth } from '../../../../Providers/AuthProvider';
import { handleInputForQtyAndValueFocus, handleInputKeyPressForQtyAndValueInput, handleOnChangeForQtyAndValueInput } from '../../../../Helpers/PriceAndValueInputHelpers';
import NewPromoSellOutTag from '../../../../Components/Components/NewPromoSellOut/NewPromoSellOutTag';
import { useOffers } from '../../../../Providers/OffersProvider';
import useGetProductImage from '../../../../Hooks/useGetProductImage';
import { useParams } from '../../../../Providers/ParamsProvider';
import useCommonFunctions from '../../Hooks/MobileAndDesktopCommon/useCommonFunctions';
import { useSavedBaskets } from '../../../../Providers/SavedBasketsProvider';

const ProductLight = ({ product, refreshPage, handleProductClick }) => {
    const decimalPlaces = product.decimalPlaces
    const inputRef = useRef(null)
    const { cartItems, GetProductQuantityInCart } = useCart()
    const navigate = useNavigate()
    const { authState } = useAuth()
    const { addProductToLastWatched } = useLastWatchedProducts()
    const [quantityInCart, setQuantityInCart] = useState(0)
    const [quantity, setQuantity] = useState(product.salesRatio > 0 ? product.salesRatio : 1)
    const { priceNet, priceGross } = useGetProductPrices(product)
    const { handleBtnOnClick } = useHandleAddToBasketBtn(product, quantity);
    const { savedOfferId, getProductQuantityInSavedOffer, selectedSavedOffer } = useOffers()
    const { GetProductImage } = useGetProductImage()
    const { isMobile } = useParams()
    const { checkIfProductCanBeAddedWithQuantity, getCartIconBackgroundColor, generateCartIcon } = useCommonFunctions()
    const { selectedSavedBasket, getProductQuantityInSavedBasket } = useSavedBaskets()

    useEffect(() => {
        if (savedOfferId != -1) {
            setQuantityInCart(getProductQuantityInSavedOffer(product))
        }
        else if (selectedSavedBasket) {
            setQuantityInCart(getProductQuantityInSavedBasket(product))
        }
        else {
            setQuantityInCart(GetProductQuantityInCart(product))
        }
    }, [[], savedOfferId, selectedSavedBasket])

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.value = parseFloat(inputRef.current.value).toFixed(decimalPlaces)
        }
    }, [quantity])

    useEffect(() => {
        let qtyToShow = quantityInCart > 0 ? quantityInCart : (product.salesRatio > 0 ? product.salesRatio : 1)
        setQuantity(qtyToShow)
    }, [quantityInCart])

    useEffect(() => {
        if (savedOfferId == -1) {
            setQuantityInCart(GetProductQuantityInCart(product))
        }
    }, [cartItems])

    useEffect(() => {
        if (savedOfferId != -1 && selectedSavedOffer && selectedSavedOffer.basketItems) {
            setQuantityInCart(getProductQuantityInSavedOffer(product))
        }
    }, [selectedSavedOffer])

    const handleRedirect = () => {
        if (authState.user) {
            addProductToLastWatched(product.index)
        }
        navigate(`/product/${product.index}`)
        if (handleProductClick) {
            handleProductClick(product.index)
        }
        else if (refreshPage) {
            window.location.reload()
        }
    }
    const OnChange = (e) => {
        if (!checkIfProductCanBeAddedWithQuantity(e.target.value, product)) {
            return
        }
        if (!handleOnChangeForQtyAndValueInput(e, decimalPlaces)) {
            e.preventDefault()
            return
        }
        setQuantity(e.target.value);
    }
    const handleInputKeyPress = (event) => {
        if (!handleInputKeyPressForQtyAndValueInput(event, decimalPlaces)) {
            event.preventDefault()
            return
        }
    }
    const handleOnKeyDown = (e) => {
        if (isMobile) {
            if ((['Enter', 'Go', 'Done', 'Next', 'Send', "Tab"].includes(e.key))) {
                e.preventDefault()
                handleBtnOnClick(quantityInCart > 0 ? 'update' : 'add')
                return
            }
        }
        else if (e.key === 'Enter') {
            handleBtnOnClick(quantityInCart > 0 ? 'update' : 'add')
        }
    }
    const handleInputLostFocus = (e) => {
        if (quantityInCart > 0) {
            setQuantity(parseFloat(quantityInCart).toFixed(decimalPlaces))
        }
        else {
            setQuantity(parseFloat(product.salesRatio > 0 ? product.salesRatio : 1).toFixed(decimalPlaces))
        }
    }

    let producerText = product.producent && product.producent.length > 1 ? product.producent.charAt(0).toUpperCase() + product.producent.slice(1).toLowerCase() : ''
    const baseUnit = product && product.baseUnit ? product.baseUnit.toLowerCase() : product.baseUnit
    const stepValue = product.salesRatio && product.salesRatio > 0 ? product.salesRatio : 1
    const salesRatioVisibility = product && product.salesRatio && product.salesRatio > 0 ? '' : 'hidden'
    const quantityTextColor = quantityInCart > 0 ? 'black' : 'var(--secondary)'

    return (
        <div className="main-container-holder row m-2">
            <div className="col-6 d-flex justify-content-start">
                <FavoriteStar
                    isFavorite={product.isFavorite}
                    index={product.index}
                    size={26}
                />
            </div>
            <div className="col-6 d-flex justify-content-end">
                <NewPromoSellOutTag product={product} />
            </div>
            <div className="col-12 mt-2 mb-2 d-flex justify-content-center">
                <div className="newProduct-img d-flex justify-content-center align-items-center" style={{ cursor: 'pointer' }} onClick={handleRedirect}>
                    <GetProductImage
                        photoFileName={product.photoFileNames[0]}
                    />
                </div>
            </div>
            <div className='d-flex flex-column' style={{ cursor: 'pointer', minHeight: '170px' }} onClick={handleRedirect}>
                <span className='light-text-color'>{producerText}</span>
                <span>{CapitalizeFirstLowercaseRest(product.title)}</span>
                <span className='secondary-text mt-2' >{CapitalizeFirstLowercaseRest(product.label)}</span>
            </div>
            <div className={`${salesRatioVisibility} d-flex justify-content-start`}>
                <span className='light-text-color'>{`Pakiet sprzedażowy: ${product.salesRatio} ${baseUnit}`}</span>
            </div>
            <div className='d-flex mt-2'>
                <b>{ConvertPriceToString(priceNet, product.currency)}</b>
                <span className='ms-1'>{'/ '}{ConvertPriceToString(priceGross, product.currency)}</span>
            </div>
            <div className='d-flex mt-2 mb-2' onBlur={handleInputLostFocus}>
                <form onSubmit={(e) => { e.preventDefault(); handleOnKeyDown(e) }}>
                    <input type='number'
                        className='biggerArrows quantity-input'
                        value={quantity}
                        onChange={OnChange}
                        onKeyPress={(e) => handleInputKeyPress(e)}
                        onFocus={handleInputForQtyAndValueFocus}
                        onKeyDown={handleOnKeyDown}
                        step={stepValue}
                        ref={inputRef}
                        style={{ color: quantityTextColor, width: '100%' }}
                    />
                </form>

                <div className='add-to-cart-icon' style={{ backgroundColor: getCartIconBackgroundColor(quantityInCart, quantity) }}
                    onMouseDown={() => handleBtnOnClick(quantityInCart > 0 ? 'update' : 'add')}>
                    {generateCartIcon(20, quantityInCart, quantity)}
                </div>
            </div>
        </div>
    )
}

export default ProductLight